import React from 'react';
import { Hero } from '../components/Hero';
import { WhatWeDo } from '../components/WhatWeDo';
import { HowItWorks } from '../components/HowItWorks';
import { Services } from '../components/Services';
import { WhoWeServe } from '../components/WhoWeServe';
import { Pricing } from '../components/Pricing';
import { Resources } from '../components/Resources';
import { Testimonials } from '../components/Testimonials';
import { FAQ } from '../components/FAQ';
import { CtaDivider } from '../components/CtaDivider';
export function HomePage() {
  return <main className="bg-white" data-id="element-394">
      <Hero data-id="element-395" />
      <WhatWeDo data-id="element-396" />
      <HowItWorks data-id="element-397" />
      <Services data-id="element-398" />
      <CtaDivider data-id="element-399" />
      <WhoWeServe data-id="element-400" />
      <Pricing data-id="element-401" />
      <Resources data-id="element-402" />
      <Testimonials data-id="element-403" />
      <FAQ data-id="element-404" />
    </main>;
}